import styled from '@emotion/styled';
import Theme from 'App.theme';

export const FileUploadContainer = styled.div`
  display: flex;
  position: relative;
  flex: 1;
  border-radius: 1rem;
  border: 2px dashed ${Theme.greys.GREY1};
`;

export const FileUploadRoot = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background-color 0.3s;

  &:hover {
    background-color: ${Theme.greys.GREY0};
  }
`;

export const FileUploadButton = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 0.5rem;

  .MuiButtonBase-root {
    font-size: 14px !important;
  }
`;
